import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  Button,
  Stack,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import { PieChart, Pie, Cell, Legend, Tooltip, ResponsiveContainer } from "recharts";

import BreadCrumbs from "../../components/navbar/BreadCrumb";
import SearchBar from "../../components/ui/SearchBar";
import LoaderImg from "../../components/ui/loader";
import Wtable from "./Wtable";
import ActiveScenariosCard from "./ActiveScenariosCard";

import userGroup from "../../assests/user_group.svg";

import {
  scenariolisting,
} from "../../APIConfig/scenarioConfig";
import {
  challengesApi,
  dashboardList,
  getCategory,
  MemberWallApi,
  topPerformerApi,
  UserProfileApi,
} from "../../APIConfig/CtfConfig";
import { totalUserCount } from "../../APIConfig/userConfig";

import ErrorHandler from "../../ErrorHandler";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./index.css";
import Logo from "../../assests/rangestormlogo.png";
// import Logo from "../../assests/CR4SA-Logo_Transperant.png";
import OWASPTraining from "../../assests/OWASP-training.png";
import Forensic from "../../assests/Forensic.png";
import WebExploitation from "../../assests/Web-Exploitation.png";
import hackerImg from "../../assests/hackerImg.png";
import Exploitation from "../../assests/Exploitation.png";
import { activeCorporateList } from "../../APIConfig/NewCorporateApiConfig";
import TopPerformer from "./TopPerformer";

const useStyles = makeStyles({
  stack: {
    transition: "transform 0.3s",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  Button: {
    backgroundColor: "#002929",
    transition: "transform 0.3s",
    fontSize: "14px !important",
    "&:hover": {
      transform: "scale(1.05)",
      backgroundColor: "#12464C",
    },
  },
});



const Dashboard = () => {
  const navigate = useNavigate();
  const classes = useStyles();

  const [cat, setCat] = useState({});
  const [mem, setMem] = useState([]);
  const [memInput, setMemInput] = useState("");
  const [scanario, setScanario] = useState([]);
  const [data, setData] = useState([]);
  const [member, setMembers] = useState({});
  const [topPerformer, setTopPerformer] = useState([]);
  const [memberWall, setMemberWall] = useState([]);
  const [challenges, setChallenges] = useState([]);
  const [totalUser, setTotalUser] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [activeScenarioList, setActiveScenarioList] = useState();

  // Mock data for chart
  const mockDataChart = [
    { name: "Solo", value: 52.1, color: "#00E0FF" },
    { name: "Corporate", value: 22.8, color: "#007580" },
    { name: "Squad", value: 13.9, color: "#1a4d4d" },
    { name: "Web Scenarios", value: 11.2, color: "#004d66" },
  ];

  // useEffect(() => {
  //   const fetchDashboardData = async () => {
  //     try {
  //       setIsActive(true);
  //       const [
  //         scenarioRes,
  //         topPerformerRes,
  //         challengesRes,
  //         membersRes,
  //         catRes,
  //         memWallRes,
  //         totalUserRes,
  //       ] = await Promise.all([
  //         scenariolisting(),
  //         topPerformerApi(),
  //         challengesApi(),
  //         dashboardList(),
  //         getCategory(),
  //         MemberWallApi(),
  //         totalUserCount(),
  //       ]);

  //       if (
  //         scenarioRes?.data &&
  //         topPerformerRes?.data &&
  //         challengesRes?.data &&
  //         membersRes?.data &&
  //         catRes?.data &&
  //         memWallRes?.data &&
  //         totalUserRes?.data
  //       ) {
  //         setScanario(scenarioRes);
  //         setData(scenarioRes?.data);
  //         setTopPerformer(topPerformerRes?.data);
  //         setChallenges(challengesRes?.data);
  //         setMembers(membersRes?.data);
  //         setCat(catRes);
  //         setMem(memWallRes?.data);
  //         setMemberWall(memWallRes?.data);
  //         setTotalUser(totalUserRes?.data.total_members);
  //       }
  //     } catch (error) {
  //       ErrorHandler(error, navigate);
  //     } finally {
  //       setIsActive(false);
  //     }
  //   };

  //   fetchDashboardData();
  // }, [navigate]);


  useEffect(() => {
    setIsActive(true)
    const getData = async () => {
      try {
        console.log('response?.data?.results')
        const response = await activeCorporateList();
        setActiveScenarioList(response?.data?.results)
        console.log(response?.data?.results, 'response?.data?.results  ')
      } catch (error) {
        ErrorHandler(error)
      } finally {
        setIsActive(false)
      }
    }
    getData();
  }, [])

  const handleSearch = (e) => {
    const searchValue = e.target.value.trimLeft().toLowerCase();

    if (!searchValue) {
      setMemberWall(mem);
      setMemInput("");
      return;
    }

    const filtered = mem.filter((item) =>
      item.user_full_name.toLowerCase().includes(searchValue)
    );
    setMemberWall(filtered);
    setMemInput(searchValue);
  };


  const featuredCategories = [

    {
      id: 1,
      title: "OWASP Training",
      image: OWASPTraining,
      description:
        "It provides hands-on practice for identifying and patching vulnerabilities identified by the OWASP community.",
    },
    {
      id: 2,
      title: "Web Exploitation",
      image: WebExploitation,
      description:
        "It provides hands-on practice for identifying and patching vulnerabilities identified by the OWASP community.",
    },
    {
      id: 3,
      title: "Cyber Attack",
      image: hackerImg,
      description:
        "It covers a broad range of threat scenarios, including phishing, malware deployment.",
    },
    {
      id: 4,
      title: "Binary Exploitation",
      image: Exploitation,
      description:
        "Identifying buffer overflows for arbitrary code execution.",
    },
    {
      id: 5,
      title: "Forensics",
      image: Forensic,
      description:
        "Analyzing attacker footprints and recovered data for root cause discovery.",
    },
  ];

  const MAX_CARDS = 5;

  const preparedData = Array.from({ length: MAX_CARDS }, (_, i) => featuredCategories[i] || null);

  const cardStyle = {
    flex: 1,
    paddingY: "20px",
    paddingX: "20px",
    borderRadius: "20px",
    backgroundColor: "#0E0E0E",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    // border:"1px solid yellow"

  };



  const breadcrumbs = [{ name: "Dashboard", link: "/" }];

  return (
    <>
      <BreadCrumbs breadcrumbs={breadcrumbs} />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        // open={isActive}
        open={false}
      >
        <LoaderImg />
      </Backdrop>

      <Stack
        sx={{
          display: "flex",
          gap: 6,
          marginTop: '6px',
          padding: '12px',
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack sx={{ width: "100%", gap: 2 }}>
          {/* Header row */}
          <Stack
            sx={{ width: "100%", height: "70%", backgroundColor: "#16181F", padding: "24px", borderRadius: "20px" }}
          >


            <Stack sx={{ fontSize: '24px', fontWeight: '600', color: '#FFFFFF', paddingY: '24px', paddingX: '4px' }}>Your Performance</Stack>
            <Stack flexDirection={'row'} gap="20px">

              <Stack
                style={{
                  backgroundColor: "#0E0E0E",
                  width: "100%",
                  borderRadius: "20px",
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  padding: "24px"


                }}
              // data-aos="fade-left"
              >
                <img
                  style={{
                    objectFit: "contain",
                    filter: "drop-shadow(0 0 8px #00E0FF)"
                  }}
                  width="70%"
                  src={Logo} alt="user_group" />
              </Stack>


              {/* Total Score Chart */}
              <Stack
                sx={{
                  backgroundColor: "#0E0E0E",
                  width: "100%",
                  borderRadius: "20px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "24px",
                }}
              // data-aos="fade-left"
              >
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#FFFFFF",
                    marginBottom: "16px",
                    alignSelf: "flex-start",
                  }}
                >
                  Total Score
                </Typography>

                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={mockDataChart}
                      cx="40%"
                      cy="45%"
                      innerRadius={50}
                      outerRadius={90}
                      paddingAngle={1}
                      dataKey="value"
                    >
                      {mockDataChart.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                    <Tooltip
                      formatter={(value) => `${value.toFixed(1)}%`}
                      contentStyle={{
                        backgroundColor: "#1a1a1a",
                        border: "1px solid #00E0FF",
                        borderRadius: "8px",
                      }}
                    />
                    <Legend
                      verticalAlign="middle"
                      align="right"
                      layout="vertical"
                      formatter={(value, entry) => `${entry.payload.name} ${entry.payload.value.toFixed(1)}%`}
                      wrapperStyle={{
                        color: "#ffffff",
                        fontSize: "13px",
                        paddingLeft: "20px",
                      }}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </Stack>
            </Stack>
          </Stack>

          {/* Categories + Scenarios */}
          <Stack
            direction="row"
            sx={{ width: "100%", gap: 2, borderRadius: "16px" }}
          >
            {/* Featured Category */}
            <Stack
              width="36%"
              // data-aos="fade-left"
              sx={{
                borderRadius: "20px",
                bgcolor: "#16181F",
                width: "100%",
                padding: 3,
              }}
            >
              {/* HEADER */}
              <Stack direction="row" justifyContent="space-between" mb={3}>
                <Typography variant="h2">Featured Category</Typography>
                {/* <Button
                  variant="contained"
                  color="primary"
                  onClick={() => navigate("/categories/soloCategory")}
                >
                  See All
                </Button> */}
              </Stack>

              {/* TOP ROW (2 CARDS) */}
              <Stack direction="row" gap="20px" mb={2.5}>
                {preparedData.slice(0, 2).map((item, index) => (
                  <Stack
                    key={index}
                    sx={{
                      ...cardStyle,
                      height: "241px",
                      backgroundColor: item ? "#0E0E0E" : "#16181F",
                      ...(item && { boxShadow: "0px 2px 2px rgba(255, 255, 255, 0.1)" }),
                    }}
                  >
                    {item && (
                      <>
                        <Box sx={{ height: "100px", display: "flex", alignItems: "center" }}>
                          <img src={item.image} style={{ width: 140, height: 100 }} />
                        </Box>

                        <Typography textAlign="center" variant="h2" mt={1}>
                          {item.title}
                        </Typography>

                        <Typography textAlign="center" variant="h5"
                          sx={{ opacity: 0.5 }} mt={1}
                        >
                          {item.description}
                        </Typography>
                      </>
                    )}
                  </Stack>
                ))}
              </Stack>

              {/* BOTTOM ROW (3 CARDS) */}
              <Stack direction="row" gap={2.5}>
                {preparedData.slice(2, 5).map((item, index) => (
                  <Stack
                    key={index}
                    sx={{
                      ...cardStyle,
                      // height: "241px",
                      backgroundColor: item ? "#0E0E0E" : "#16181F",
                      textAlign: "center",
                      ...(item && { boxShadow: "0px 2px 2px rgba(255, 255, 255, 0.1)" }),
                    }}
                  >
                    {item && (
                      <>
                        <Box sx={{ height: "90px", display: "flex", alignItems: "center" }}>
                          <img src={item.image} style={{ width: 88, height: 90 }} />
                        </Box>

                        <Typography variant="h2" mt={1}>
                          {item.title}
                        </Typography>

                        <Typography variant="h5"
                          sx={{ opacity: 0.5 }} mt={1}>
                          {item.description}
                        </Typography>
                      </>
                    )}
                  </Stack>
                ))}
              </Stack>
            </Stack>

            {/* Scenarios */}
            <Stack
              sx={{
                backgroundColor: "custom.main",
                borderRadius: "16px",
                padding: 3,
              }}

              width="64%"
            // data-aos="fade-left"
            >
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="h2">Active Scenarios</Typography>
                <Button
                  variant="contained"
                  onClick={() => navigate("/scenarios/active-scenarios")}
                >
                  See All
                </Button>
              </Stack>

              <Stack width="100%" gap={5} mt={4}>
                {activeScenarioList?.length ? (
                  activeScenarioList.slice(0, 2).map((item, index) => (
                    <>
                      {/* <ScenarioMachine item={item} key={index} /> */}
                      <ActiveScenariosCard item={item} key={index}  />
                    </>
                  ))
                ) : (
                  <Stack alignItems="center">
                    <Typography>No data!!!</Typography>
                  </Stack>
                )}
              </Stack>
            </Stack>
          </Stack>
          <TopPerformer />


        </Stack >
      </Stack >
    </>
  );
};

export default Dashboard;
